<template>
  <router-link v-bind:to="path">
    <img src="/static/help.png" class="help-icon" v-bind:class="{ 'top-right': position === 'top-right' }">
  </router-link>
</template>

<script>
export default {
  name: 'help-icon',
  props: ['path', 'position'],
}
</script>

<style lang="scss" scoped>
  .help-icon {
    position: fixed;
    top: unset;
    bottom: 23px;
    right: 160px;
    z-index: 5;
    width: 90px;

    &.top-right {
      top: 60px;
      right: 10px;
    }
  }

  @media (max-device-width: 460px) {
    .help-icon {
      width: 65px;
      bottom: 16px;
      right: 110px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/help-icon.vue